const svgString2base64Svg = (svgString) => {
    // Serialize the svg to string
    //var svgString = new XMLSerializer().serializeToString(svgElement);
    // Remove any characters outside the Latin1 range
    let decoded = unescape(encodeURIComponent(svgString));
    // Now we can use btoa to convert the svg to base64
    let base64Svg = btoa(decoded);
    base64Svg = `data:image/svg+xml;base64,${base64Svg}`;
    return base64Svg;
}

const svg2base64Svg = (svg) => {
    return svgString2base64Svg(svg);
}

export interface SvgPngImage {
    base64png: string;
    width: number,
    height: number,
}

export class SvgUtils {
    public static svgImageToPngImage = async (svg) => {
        let base64Svg = svg2base64Svg(svg);
        const waitForImage = imgElem => new Promise(resolve => imgElem.complete ? resolve : imgElem.onload = imgElem.onerror = resolve);
        let img = new Image();
        img.src = base64Svg;
        await waitForImage(img);
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        let ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        let base64png = canvas.toDataURL('image/png', 1.0);
        let res: SvgPngImage =
        {
            base64png: base64png,
            width: img.width,
            height: img.height,
        }
        return res;
    }
}
